import { trigger, state, style, transition, animate } from '@angular/animations';

export const ColorInOutAnimation = trigger('colorInOut', [
    state('In', style( {
        'background-color': '#8bb389'
    })),
    state('Out', style({
        'background-color': 'transparent'
    })),
    transition('In => Out', animate('1000ms ease-in-out'))
]);